var _path, _path2, _polygon, _path3, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 325 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.22,161.561h80.769C324.481,72.248,251.932,0,162.5,0,73.696,0,1.541,71.237.035,159.682h78.24v16.281H.559c6.845,83.446,76.729,149.037,161.941,149.037,84.571,0,154.042-64.608,161.774-147.158h-80.054v-16.281Z",
    fill: "#676bb2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M324.988,161.561h-64.487v-60.116h-16.281v76.397h80.054c.473-5.051.726-10.167.726-15.342,0-.314-.01-.626-.012-.939Z",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "201.012 80.78 184.73 80.78 184.73 204.769 184.73 219.171 184.73 221.05 286.175 221.05 286.175 204.769 201.012 204.769 201.012 80.78",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.276,175.963v-69.509h-16.281v53.227H.035c-.016.938-.035,1.876-.035,2.818,0,4.534.195,9.023.559,13.463h77.717Z",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "121.484 204.769 36.32 204.769 36.32 221.05 137.765 221.05 137.765 219.171 137.765 204.769 137.765 80.78 121.484 80.78 121.484 204.769",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/Logo_svg.ab7b863ad7e3ba425fe32cefe8eb4737.svg";
export { ForwardRef as ReactComponent };